import { CommonModule } from "@angular/common";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";

import * as forge from "@tylertech/forge";
forge.defineButtonComponent();
forge.defineIconButtonComponent();
forge.defineIconComponent();
forge.defineMenuComponent();
forge.defineTooltipComponent();

import { CommandMenuComponent, CommandBarComponent, CommandComponent } from "./components";
import { CommandService } from "./services";

const angularModules = [
    CommonModule
];

const exportedComponents = [
    CommandMenuComponent,
    CommandBarComponent,
    CommandComponent
];

@NgModule({
    imports: [
        ...angularModules,
    ],
    declarations: [
        ...exportedComponents,
    ],
    exports: exportedComponents,
    providers: [
        CommandService
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CommandsModule
{

}
